import { CopyIcon } from '#assets/ReactSvg.ts';
import { IconButton } from './icon-button/IconButton.tsx';
import type { IconButtonProps } from './types.ts';

export function CopyIconButton({ size, title = 'Copy', ...buttonProps }: IconButtonProps) {
  return (
    <IconButton title={title} height={size} width={size} {...buttonProps}>
      <CopyIcon />
    </IconButton>
  );
}
